import { render } from "./index.vue?vue&type=template&id=1936854e&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=1936854e&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/t3_d_M4E/0/hellmanh/rb-app-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1936854e"]])

export default __exports__